import { useEffect, useState } from "react";

// Constants
import { COUNTRY_CURRENCY } from "constants/currency";
import {
  STORAGE_CURRENCY_FROM_LINK,
  STORAGE_USER_COUNTRY,
} from "constants/variables";

// Selectors
import { useCatalogsStore } from "stores/catalogs";

export const useCurrency = () => {
  const [defaultCurrency, setDefaultCurrency] = useState("");
  const currencies = useCatalogsStore((state) => state.currencies);

  const country = localStorage.getItem(STORAGE_USER_COUNTRY);
  const currencyFromLink = localStorage.getItem(STORAGE_CURRENCY_FROM_LINK);
  const countryObject = COUNTRY_CURRENCY.find(
    (item) => item.country === country,
  );

  useEffect(() => {
    if (currencyFromLink) {
      setDefaultCurrency(currencyFromLink);
      return;
    }
    if (countryObject) {
      const avaliableCurrency = currencies?.find(
        (currency) => currency.isoCode === countryObject.currencyIso,
      );
      if (avaliableCurrency) {
        setDefaultCurrency(avaliableCurrency.isoCode);
      } else if (currencies && Array.isArray(currencies)) {
        setDefaultCurrency(currencies[currencies.length - 1].isoCode);
      }
    } else if (currencies && Array.isArray(currencies)) {
      setDefaultCurrency(currencies[currencies.length - 1].isoCode);
    }
  }, [countryObject, currencies, country, currencyFromLink]);

  return defaultCurrency;
};
